<div class="pt-3 pl-md-4" *ngIf="discountNotFound">
  <h2>Discount not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingDiscount">
  <h2>Loading Discount...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewDiscount ? 'create' : 'edit' }}
    discounts.
  </h2>
</div>

<div *ngIf="(serverError === null) && !discountNotFound && !loadingExistingDiscount && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/events/setup/discounts" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for discounts -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-danger btn-sm ml-2"
              *ngIf="!isNewDiscount"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleDelete()">
        {{ loadingDelete ? 'Deleting...' : 'Delete' }}
      </button>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 mb-6">
      <h2>
        {{ isNewDiscount ? 'New Discount' : 'Edit Discount' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <label class="mb-1">Pricing Matrices This Discount Applies To</label>
              <span *ngIf="loadingEventTypesWithPricingMatrices" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingEventTypesWithPricingMatrices">
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        type="button"
                        *ngIf="!allPricingMatricesAreSelected()"
                        (click)="setAllPricingMatricesSelected(); unsavedChanges = true;">
                  Select All
                </button>
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        type="button"
                        *ngIf="allPricingMatricesAreSelected()"
                        (click)="setNoPricingMatricesSelected(); unsavedChanges = true;">
                  Deselect All
                </button>
                <ng-container *ngFor="let eventTypeWithPricingMatrices of getFilteredEventTypesWithPricingMatrices()">
                  <div class="form-check" *ngFor="let pricingMatrix of eventTypeWithPricingMatrices.pricing_matrices">
                    <input class="form-check-input" type="checkbox" id="pmCheckbox{{ pricingMatrix.id }}"
                           [checked]="pricingMatrixSelected(pricingMatrix)"
                           (click)="togglePricingMatrix(pricingMatrix); unsavedChanges = true;">
                    <label class="form-check-label" for="pmCheckbox{{ pricingMatrix.id }}">
                      {{ eventTypeWithPricingMatrices.name }} - {{ pricingMatrix.name }}
                      <span *ngIf="eventTypeWithPricingMatrices.status === EventTypeStatus.draft">(Draft)</span>
                      <span *ngIf="eventTypeWithPricingMatrices.status === EventTypeStatus.retired">(Retired)</span>
                    </label>
                  </div>
                </ng-container>
              </ng-container>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isAutomaticSelect">Discount Type</label>
                  <select id="isAutomaticSelect" name="is_automatic"
                          class="custom-select"
                          [(ngModel)]="discount.is_automatic"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">Code</option>
                    <option [ngValue]="true">Automatic</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Code", then the customer must enter the discount code in order to use the discount. If this is set to "Automatic", then the discount will automatically be applied to any qualifying purchases. <br>
                Automatic discounts may still have a code configured for reporting purposes.
              </small>
              <div class="form-text text-danger">{{ errors.is_automatic }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="codeInput">
                    Code
                    <span *ngIf="discount.is_automatic">(optional)</span>
                  </label>
                  <input id="codeInput" type="text" name="code"
                         class="form-control"
                         [(ngModel)]="discount.code"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                This is what a customer must enter in order to apply the discount.
              </small>
              <div class="form-text text-danger">{{ errors.code }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">
                    Name
                    <span *ngIf="!discount.is_automatic">(optional)</span>
                  </label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="discount.name"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this will be displayed in place of the discount code on the customer's receipt and in the payment table.
              </small>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="discountTypeSelect">Discount Value</label>
                  <select id="discountTypeSelect" name="discount_type"
                          class="custom-select"
                          [(ngModel)]="discount.discount_type"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="EventDiscountType.currency">Flat Discount</option>
                    <option [ngValue]="EventDiscountType.percentage">Percentage</option>
                  </select>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.discount_type }}</div>
            </div>

            <div class="form-group">
              <label for="amountInput">Amount</label>
              <div class="row">
                <div class="input-group col-lg-3 col-md-4 col-sm-5">
                  <div class="input-group-prepend" *ngIf="discount.discount_type === EventDiscountType.currency">
                    <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                  </div>
                  <input id="amountInput" type="number" name="amount"
                         min="0"
                         [max]="discount.discount_type === EventDiscountType.currency ? '' : '100'"
                         [step]="discount.discount_type === EventDiscountType.currency ? '0.01' : '1'"
                         class="form-control"
                         [(ngModel)]="discount.amount"
                         (ngModelChange)="unsavedChanges = true">
                  <div class="input-group-append" *ngIf="discount.discount_type === EventDiscountType.percentage">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If a discount ever exceeds the total purchase amount, the purchase will be free.
              </small>
              <div class="form-text text-danger">{{ errors.amount }}</div>
            </div>

            <div class="form-group" *ngIf="discount.discount_type === EventDiscountType.currency">
              <label for="isPerParticipantSelect">Scope</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select class="custom-select" id="isPerParticipantSelect" name="is_per_participant"
                          [(ngModel)]="discount.is_per_participant"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Per-Participant</option>
                    <option [ngValue]="false">Per-Booking</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Whether this discount is applied for each paying participant, or once for the entire booking.
              </small>
              <div class="form-text text-danger">{{ errors.is_per_participant }}</div>
            </div>

            <div class="form-group" *ngIf="discount.discount_type === EventDiscountType.percentage">
              <label for="appliesToAddOnsSelect">Does this discount apply to add-ons?</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select class="custom-select" id="appliesToAddOnsSelect" name="applies_to_add_ons"
                          [(ngModel)]="discount.applies_to_add_ons"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If "Yes", this discount will be applied to add-ons, in addition to the base fee.
              </small>
              <div class="form-text text-danger">{{ errors.applies_to_add_ons }}</div>
            </div>

            <div class="form-group">
              <label class="mb-1">Availability (optional)</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <div class="row">
                    <div class="col">
                      <label for="startDateInput">Start Date</label>
                      <app-date-picker [id]="'startDateInput'"
                                       [(content)]="discount.start_date"
                                       (contentChange)="unsavedChanges = true"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.start_date }}</div>
                    </div>
                    <div class="col">
                      <label for="endDateInput">End Date</label>
                      <app-date-picker [id]="'endDateInput'"
                                       [(content)]="discount.end_date"
                                       (contentChange)="unsavedChanges = true"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.end_date }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, these dates limit when customers can use this discount. These dates are inclusive, so the discount is available from beginning of the Start Date to the end of the End Date, in the local time of your organization. In order to add a discount which is available for a single day, set both Start Date and End Date to that day.
              </small>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="requiresAssociationSelect">Does this discount require an association?</label>
                  <select id="requiresAssociationSelect" name="requires_association"
                          class="custom-select"
                          [(ngModel)]="discount.requires_association"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the discount may only be used for products purchased for customers in the chosen associations. For products purchased for multiple customers (for example, group memberships and multiple-participant event bookings), each customer must belong to one of the chosen associations.
              </small>
              <div class="form-text text-danger">{{ errors.requires_association }}</div>
            </div>

            <div class="form-group" *ngIf="discount.requires_association">
              <label class="mb-1">Associations Granting Discount</label>
              <span *ngIf="loadingAssociations" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingAssociations">
                <ng-container *ngIf="associations.length > 0">
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="!allAssociationsAreSelected()"
                          (click)="setAllAssociationsSelected(); unsavedChanges = true;">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="allAssociationsAreSelected()"
                          (click)="setNoAssociationsSelected(); unsavedChanges = true;">
                    Deselect All
                  </button>
                  <div class="form-check" *ngFor="let association of associations">
                    <input class="form-check-input" type="checkbox" id="associationCheckbox{{ association.id }}"
                           [checked]="associationSelected(association)"
                           (click)="toggleAssociation(association); unsavedChanges = true;">
                    <label class="form-check-label" for="associationCheckbox{{ association.id }}">
                      {{ association.name }}
                    </label>
                  </div>
                </ng-container>
                <span *ngIf="associations.length === 0" class="d-block text-muted">
                  No associations configured
                </span>
              </ng-container>
            </div>

            <div class="form-group" *ngIf="discount.requires_association">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="requiresAllAssociationsSelect">How many of these associations must the customer belong to?</label>
                  <select id="requiresAllAssociationsSelect" name="requires_all_associations"
                          class="custom-select"
                          [(ngModel)]="discount.requires_all_associations"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">Any one of them</option>
                    <option [ngValue]="true">All of them</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "All of them", then the discount may only be used by customers who belong to every one of the associations chosen above. For products purchased for multiple customers (for example, group memberships and multiple-participant event bookings), each customer must belong to every chosen association.
              </small>
              <div class="form-text text-danger">{{ errors.requires_all_associations }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="requiresMembershipSelect">Does this discount require an active membership?</label>
                  <select id="requiresMembershipSelect" name="requires_membership"
                          class="custom-select"
                          [(ngModel)]="discount.requires_membership"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the discount may only be used for products purchased for customers with active memberships of the chosen types. For products purchased for multiple customers (for example, group memberships and multiple-participant event bookings), each customer must belong to one of the chosen memberships.
              </small>
              <div class="form-text text-danger">{{ errors.requires_membership }}</div>
            </div>

            <div class="form-group" *ngIf="discount.requires_membership">
              <label class="mb-1">Memberships Granting Discount</label>
              <span *ngIf="loadingMemberships" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingMemberships">
                <ng-container *ngIf="memberships.length > 0">
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="!allRequiredMembershipsAreSelected()"
                          (click)="setAllRequiredMembershipsSelected(); unsavedChanges = true;">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="allRequiredMembershipsAreSelected()"
                          (click)="setNoRequiredMembershipsSelected(); unsavedChanges = true;">
                    Deselect All
                  </button>
                  <div class="form-check" *ngFor="let membership of memberships">
                    <input class="form-check-input" type="checkbox" id="requiredMembershipCheckbox{{ membership.id }}"
                           [checked]="requiredMembershipSelected(membership)"
                           (click)="toggleRequiredMembership(membership); unsavedChanges = true;">
                    <label class="form-check-label" for="requiredMembershipCheckbox{{ membership.id }}">
                      {{ membership.name }}
                      <span *ngIf="membership.status === MembershipStatus.draft">(Draft)</span>
                      <span *ngIf="membership.status === MembershipStatus.retired">(Retired)</span>
                    </label>
                  </div>
                </ng-container>
                <span *ngIf="memberships.length === 0" class="d-block text-muted">
                  No memberships configured
                </span>
              </ng-container>
            </div>

            <div class="form-group">
              <label for="maxUsesPerCustomerInput">
                Max Number of Uses Per Customer
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4">
                  <input id="maxUsesPerCustomerInput"
                         type="number" step="1" min="1"
                         name="max_number_of_uses_per_customer"
                         class="form-control"
                         [(ngModel)]="discount.max_number_of_uses_per_customer">
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, this limits the number of times that a customer can use this discount. For bookings with multiple participants, all participants must be under the limit in order to use the discount. Leave this blank for no limit.
                <br>
                This limit applies to the participants, not necessarily the customer making the booking.
                <br>
                If a limit is configured, the discount cannot be used for unlinked purchases.
              </small>
              <div class="form-text text-danger">{{ errors.max_number_of_uses_per_customer }}</div>
            </div>

            <div class="form-group">
              <label for="required_no_check_in_period_days">
                Minimum Number of Days Since Last Check-In
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4">
                  <input type="number" step="1" min="1"
                         id="required_no_check_in_period_days"
                         name="required_no_check_in_period_days"
                         class="form-control"
                         [(ngModel)]="discount.required_no_check_in_period_days">
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, this discount may only be used if the customer has not checked into <b>any</b> location within your organization in the given time period. Leave this blank for no restriction.
              </small>
              <div class="form-text text-danger">{{ errors.required_no_check_in_period_days }}</div>
            </div>

            <div class="form-group">
              <label>
                Required Lifetime Check-In Count
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 mb-md-0 mb-1">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Min</span>
                    </div>
                    <input class="form-control"
                           id="min_check_in_count" name="min_check_in_count"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.min_check_in_count">
                  </div>
                </div>
                <div class="col-lg-3 col-md-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Max</span>
                    </div>
                    <input class="form-control"
                           id="max_check_in_count" name="max_check_in_count"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.max_check_in_count">
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be used for customers with a total lifetime check-in count in the provided range.
              </small>
              <div class="form-text text-danger">{{ errors.min_check_in_count }}</div>
              <div class="form-text text-danger">{{ errors.max_check_in_count }}</div>
            </div>

            <div class="form-group">
              <label>
                Required Age (Years)
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 mb-md-0 mb-1">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Min</span>
                    </div>
                    <input class="form-control"
                           id="min_age" name="min_age"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.min_age">
                  </div>
                </div>
                <div class="col-lg-3 col-md-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Max</span>
                    </div>
                    <input class="form-control"
                           id="max_age" name="max_age"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.max_age">
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be used for customers who fall in the provided age range at the time of payment.
              </small>
              <div class="form-text text-danger">{{ errors.min_age }}</div>
              <div class="form-text text-danger">{{ errors.max_age }}</div>
            </div>

            <div class="form-group">
              <label for="min_number_of_days_without_membership">
                Minimum Number of Days Without a Membership
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4">
                  <input class="form-control"
                         id="min_number_of_days_without_membership"
                         name="min_number_of_days_without_membership"
                         type="number" min="0" step="1"
                         [(ngModel)]="discount.min_number_of_days_without_membership">
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be used for customers who do not have an active or frozen membership, and who have not had one within the provided number of days.
              </small>
              <div class="form-text text-danger">{{ errors.min_number_of_days_without_membership }}</div>
            </div>

            <div class="form-group">
              <label>
                Days Until Event Start
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 mb-md-0 mb-1">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Begin</span>
                    </div>
                    <input class="form-control"
                           id="min_days_until_event_start"
                           name="min_days_until_event_start"
                           type="number" step="1"
                           [(ngModel)]="discount.max_days_until_event_start">
                  </div>
                </div>
                <div class="col-lg-3 col-md-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">End</span>
                    </div>
                    <input class="form-control"
                           id="max_days_until_event_start" name="max_days_until_event_start"
                           type="number" step="1"
                           [(ngModel)]="discount.min_days_until_event_start">
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be in the provided range of days before the event start. Negative values may be used to offer discounts after the event has started, for cases such as pro-rating a multi-week course. For example, to configure a discount which is available the day after the event starts (and indefinitely thereafter), set Begin to "-1" and leave End blank.
              </small>
              <div class="form-text text-danger">{{ errors.min_days_until_event_start }}</div>
              <div class="form-text text-danger">{{ errors.max_days_until_event_start }}</div>
            </div>

          </div>
        </div>

        <!-- Allows inputs to submit when enter is pressed -->
        <button type="submit" class="d-none">Hidden submit button</button>
      </form>
    </div>
  </div>
</div>
